"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _button = require("../../button");

var _context = require("../../context");

var _constants = require("./constants");

var DateButton = (0, _context.styledWithTheme)(_button.Button)(function (_ref) {
  var _ref$theme = _ref.theme,
      selectors = _ref$theme.selectors,
      isInHighContrast = _ref$theme.isInHighContrast,
      isInCurrentMonth = _ref.isInCurrentMonth,
      isSelected = _ref.isSelected,
      isSelectedTwice = _ref.isSelectedTwice,
      isInSelectionRange = _ref.isInSelectionRange,
      isHighlighted = _ref.isHighlighted,
      disabled = _ref.disabled;
  var fontWeight = isInCurrentMonth && !disabled ? selectors.fontWeight('medium') : selectors.fontWeight('regular');
  var outline = 'none';
  var border = 'none';
  var borderWidth = '2px';
  var backgroundClip = 'border-box';
  var padding = '0';
  var outlineOffset = "-".concat(_constants.FOCUS_OFFSET, "px");
  var background = 'transparent';
  var zIndex = 0;
  var color = isInCurrentMonth ? selectors.color('primary70') : selectors.color('neutral70');

  if (isSelected) {
    outlineOffset = "".concat(_constants.FOCUS_OFFSET, "px");
    background = selectors.color('primary70');
    color = selectors.color('neutral0');

    if (isInHighContrast) {
      border = "solid transparent";
    }
  }

  if (isInSelectionRange) {
    background = selectors.color('neutral10');

    if (isInHighContrast) {
      border = "solid transparent";
      borderWidth = "2px 0";
    }
  }

  if (isHighlighted) {
    zIndex = 1;

    if (!isSelectedTwice) {
      outline = "2px solid ".concat(selectors.color('primary70'));
    }
  }

  if (isSelectedTwice) {
    border = "solid ".concat(selectors.color('primary70'));
    borderWidth = '3px';
    backgroundClip = 'content-box';
    padding = '2px';
  }

  return "\n      align-items: center;\n      border: ".concat(border, ";\n      border-width: ").concat(borderWidth, ";\n      border-radius: 0;\n      background-clip: ").concat(backgroundClip, ";\n      position: relative;\n      width: ").concat(_constants.CALENDAR_CELL_SIZE, "px;\n      height: ").concat(_constants.CALENDAR_CELL_SIZE, "px;\n      padding: ").concat(padding, ";\n      color: ").concat(color, ";\n      background-color: ").concat(background, ";\n      font-weight: ").concat(fontWeight, ";\n      z-index: ").concat(zIndex, ";\n      outline: ").concat(outline, ";\n      outline-offset: ").concat(outlineOffset, ";\n\n      &:hover {\n        border: ").concat(border, ";\n        border-width: ").concat(borderWidth, ";\n        color: ").concat(color, ";\n        background-color: ").concat(background, ";\n        text-decoration: none;\n        outline: ").concat(outline, ";\n        outline-offset: ").concat(outlineOffset, ";\n      }\n\n      &:focus {\n        border: ").concat(border, ";\n        border-width: ").concat(borderWidth, ";\n        color: ").concat(color, ";\n        background-color: ").concat(background, ";\n        outline: ").concat(outline, ";\n        outline-offset: ").concat(outlineOffset, ";\n        \n        :before {\n          content: none;\n        }\n      }\n    ");
});
DateButton.defaultProps = {
  variant: _button.ButtonVariant.Tertiary
};
DateButton.displayName = 'DateButton';
var _default = DateButton;
exports.default = _default;